<div class="_impact-statistic-component">

    <div class="_statistic-filters" *ngIf="!hideFilters">
        <statistic-filter-component [params]="params" [paramsChanged]="paramsChanged" [filters]="filters"></statistic-filter-component>
	</div>	

    <div class="_statistic-components" [ngClass]="{'_hidden-filters': hideFilters}">
        <div class="_statistics-container">
            <div class="_statistic-container _full-width-without-height">
                <impact-count-statistic-component [params]="params" [paramsChanged]="paramsChanged"></impact-count-statistic-component>
            </div>
        </div>
    </div>

</div>



